<template>
  <div class="text-link-wrap">
    <p
      @click="goLink"
      class="text-link-open"
      :style="{textAlign:formItem.align||'left',color:formItem.color,padding:formItem.padding||0}"
    >{{title}}</p>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { ends } from "../../tools/constant";
import { openWebview } from "../../tools/utils";
export default {
  props: ["formItem", "idx"],
  data() {
    return {  };
  },
  computed: {
    ...mapState(["_uuid", "_ticket"]),
    title() {
      return this.formItem.text || this.formItem.title || this.formItem.link
    }
  },
  methods: {
    goLink() {
      let l = this.formItem.link;
      if (this.formItem.is_white) {
        let up = new URLSearchParams(location.search);
        if (this._ticket) {
          up.set("token", this._ticket);
          up.delete("ticket");
        }
        if (l.indexOf("?") > -1) {
          l = `${l}&${up}`;
        } else {
          l = `${l}?${up}`;
        }
      }

      if (ends.inApp) {
        // let module = null;
        // if (Fusion && Fusion.loadModule) {
        //   module = Fusion.loadModule("newPageModule")
        // }
        // //@20180531 检测module，app内新page打开或者直接打开,每个打开窗口都需要知道，是否是盘古、活动通告
        // if (module.openNewPage) {
        //   module.openNewPage(
        //     {
        //       url: l
        //     },
        //     function (res) {
        //     }
        //   )
        // }
        openWebview(l);
      } else {
        window.open(l);
      }
      return;
    },
  }
};
</script>
<style lang="scss" scoped>
.text-link-open {
  font-size: .28rem;
  color: #0097FF;
  line-height: .4rem;
}
</style>

